export default "__VITE_ASSET__423fe695__"